import { ScheduleRelationshipBase } from './base/schedule-relationship-base';

export class ScheduleRelationship extends ScheduleRelationshipBase { }